const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|mkv|m4v)$/i;
const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg|ico|avif|heic)$/i;
const MODEL_3D_EXT = /\.(obj|stl|3mf|step|stp|fbx|ply|glb|gltf|amf)$/i;

/**
 * True if the asset should be shown as an image in gallery/lightbox.
 */
export function isImageMimeOrExtension(mimeType, filename) {
  if (mimeType?.startsWith('image/')) return true;
  if (!filename || !IMAGE_EXT.test(filename)) return false;
  if (!mimeType || mimeType === 'application/octet-stream') return true;
  return false;
}

/**
 * True if the asset should be treated as video (browser can play via <video>).
 * Handles application/octet-stream and missing mime when the filename has a known video extension.
 */
export function isVideoMimeOrExtension(mimeType, filename) {
  if (mimeType?.startsWith('video/')) return true;
  if (!filename || !VIDEO_EXT.test(filename)) return false;
  if (!mimeType || mimeType === 'application/octet-stream') return true;
  return false;
}

/**
 * True if the asset is a 3D model file that can be opened locally.
 * Matches by mime type prefix model/ or by known 3D file extensions.
 */
export function isModel3DMedia(mimeType, filename) {
  if (mimeType?.startsWith('model/')) return true;
  if (!filename) return false;
  return MODEL_3D_EXT.test(filename);
}
